import React from 'react';
import { DateInput } from 'semantic-ui-calendar-react';

const ResponsiveDateInput = (props : any) => {
    const { isMobile } = props;
    const formatMobileDate = (date: string) => {
        if (date.length !== 10) return '';
        return `${date.slice(6)}-${date.slice(3,5)}-${date.slice(0,2)}`;
    }

    const handleChange = (name: any, value: any) => {
        const { isMobile, setFieldValue } = props; 
        
        function formatDate (value : string) {
            let dateStr = value.slice(-2) + '/' + value.slice(5,7) + '/' + value.slice(0, 4);
            return dateStr;
        }
        setFieldValue(name, (isMobile ? formatDate(value): value))
    }
    const popUpProp = isMobile ? { popupIsClosed: true, type : "date" } : {};

    return (
            <DateInput
              dateFormat="DD/MM/YYYY"
              name={props.name}
              label={props.label}
              hideMobileKeyboard={isMobile ? false : true}
              popupPosition="bottom center"
              {...popUpProp}
              value={isMobile ? formatMobileDate(props.values[props.name]) : props.values[props.name]}
              closable={true}
              id={props.id}
              placeholder="DD/MM/YYYY"
              pattern="\d{1,2}/\d{1,2}/\d{4}"
              onChange={(e, {name, value}) => {handleChange(name, value)}}
              animation={'fade'}
              autoComplete="off"
              startMode="year"
              data-testid={props.dataTestid}
            />  
    );
}

export default ResponsiveDateInput;